export const AUTH_REQUESTED = "AUTH_REQUESTED";
export const AUTH_RECEIVED = "AUTH_RECEIVED";
export const AUTH_REQUEST_FAILED = "AUTH_REQUEST_FAILED";
export const AUTH_SIGN_OUT = "AUTH_SIGN_OUT";

export const requestAuth = () => ({ type: AUTH_REQUESTED });
export const receiveAuth = () => ({ type: AUTH_RECEIVED });
export const requestSignOut = () => ({ type: AUTH_SIGN_OUT });
